
/**
 * Created by LiZhenlin
 * 清先阅读快速入门
 * 
 * 配置项：
 * 
 * @param {String|Number|Date} currentTime  当前时间
 * @param {String|Number|Date} endTime 结束时间 *必传参数*
 * @param {Number} formatType 结果格式化类型; @type 0 = [h, m, s]; 1 = [d, h, m, s]; 2 = [h, m, s, ss]; 3 = [d, h, m, s, ss]
 * @param {Number} countdownFrame 几秒进行一次倒计时(ms)
 * @param {Function} update 倒计时更新后触发 *必传参数*
 * @param {Function} end 倒计时结束时触发 *必传参数*
 * 
 * @method startCountDown 开始倒计时
 * @method endCountDown 结束倒计时
 * @method updateCountDown 更新倒计时 @param {Object} options 倒计时配置，参考上方
 * 
 * 
 * 使用方法
 * import CountDown from 'yourpath/countdown-tool.js'
 * 
 * 第一步：实例化，之后倒计时就开始了
 * const tool = new CountDown({
 *  currentTime: Number.parseInt(+new Date() / 1000, 10),
 *  endTime: Number.parseInt(+new Date('2020/09/14 18:40:00') / 1000, 10),
 *  formatType: 0,
 *  countdownFrame: 1000,
 *  update: (res) => { console.log('result', res); },
 *  end: () => { console.log('end'); }
 * });
 * 
 * // 停止倒计时
 * tool.endCountDown();
 * 
 * // 更新倒计时
 * tool.updateCountDown({...options});
 */
const requiredParams = ['endTime', 'update', 'end']
class CountDown {
  constructor(options) {
    console.log('options', options)
    this._status = {
      countdownTime: 0,
      countdownTimer: null,
      ss: 9,
      last: null,
    }
    this.updateCountDown(options)
    
  }

  /**
   * 开始倒计时
   */
  startCountDown = () => {
    // 开始前先清除
    if (this._status.countdownTimer) {
      clearTimeout(this._status.countdownTimer)
      this._status.countdownTimer = null;
    }
    setTimeout(() => {
      handleCountdown(this)
    }, this.countdownFrame);
  }

  /**
   * 结束倒计时
   */
  endCountDown = () => {
    if (!this._status.countdownTimer) return;
    clearTimeout(this._status.countdownTimer)
    this._status = {
      countdownTime: 0,
      countdownTimer: null,
      ss: 9,
      last: null,
    } 
  }

  /**
   * 更新倒计时
   * @param {Object} options 
   */
  updateCountDown = (options) => {
    // 必须是开启状态
    if (this._status.countdownTimer) {
      clearTimeout(this._status.countdownTimer);
      this._status = {
        countdownTime: 0,
        countdownTimer: null,
        ss: 9,
        last: null,
      }
    }
    validRequireParam(requiredParams, options)
    // 赋值
    const { currentTime = +new Date(), endTime, formatType = 1, countdownFrame = 1000 } = options;
    this.options = options;
    this.currentTime = formatTimeStamp(currentTime)
    this.endTime = formatTimeStamp(endTime)
    this.formatType = formatType
    this.countdownFrame = countdownFrame
    this.result = null;
    this._status.countdownTime = this.currentTime
    // 判断是否为毫秒格式化，如果为是则为100ms更新一次
    if (this.formatType === 2 || this.formatType === 3) {
      this.options.countdownFrame = 100
      this.countdownFrame = 100
    }
    // 开启倒计时
    this.startCountDown()
  }

  /**
   * 更新时触发方法
   */
  onUpdate = (res) => {
    this.result = res;
    this.options.update(res)
  }

  /**
   * 倒计时结束触发
   */
  onEnd = () => {
    this.options.end()
  }
}

/**
 * 处理倒计时
 * @param {Object = Pointer} self 当前实例指针
 */
function handleCountdown(self) {
  // 校正逻辑
  let correction=0;
  if(self._status.last) {
    const now = +new Date()
    correction = self.countdownFrame - (now - self._status.last)
    self._status.last = now
  }else {
    self._status.last = +new Date()
  }
  // 增加当前时间
  self._status.countdownTime += self.countdownFrame - correction

  // 计算倒计时返回值
  const result = formatCountdownResult(self)
  if (!result) {
    self.onEnd()
    if (self._status.countdownTimer) {
      clearTimeout(self._status.countdownTimer)
      self._status =  {
        countdownTime: 0,
        countdownTimer: null,
        ss: 9,
        last: null,
      }
    }
    return;
  }
  // 触发更新callback
  self.onUpdate(result)
  self._status.countdownTimer = setTimeout(() => {
    if (self.formatType === 2) {
      self._status.ss -= 1
      if (self._status.ss < 0) self._status.ss = 9
    }
    handleCountdown(self)
  }, self.countdownFrame);
}

/**
 * 生成格式化好的结果
 * @param {Object = Pointer} self 当前实例指针
 * @returns {Array} 格式化好的倒计时
 */
function formatCountdownResult(self) {
  const lefttime = self.endTime - self._status.countdownTime;
  // 已结束
  if (lefttime < 0) return false
  const d = lessTen(parseInt(lefttime / ((24 * 60 * 60) * 1000), 10))
  const h = lessTen(parseInt(lefttime / (60 * 60 * 1000) % 24, 10));
  const m = lessTen(parseInt(lefttime / (60 * 1000) % 60, 10));
  const s = lessTen(parseInt(lefttime % (60 * 1000) / 1000, 10));
  let res;
  switch (self.formatType) {
    case 0:
      res = [h, m, s]
      break;
    case 1:
      res = [d, h, m, s]
      break;
    case 2:
      res = [h, m, s, lessTen(self._status.ss)]
      break;
    case 3:
      res = [d, h, m, s, lessTen(self._status.ss)]
      break;
    default:
      throw new Error('formatType is invalid!')
  }
  return res
}


/**
 * 时间戳格式统一
 * @param t {String|Number|Date} 格式化前时间
 * @returns {Number} 正常时间戳
 */
function formatTimeStamp(t) {
  let res;
  if (getProto(t) === '[object Date]') {
    // 时间对象
    res = +t;
  } else {
    const tlen = Number.parseInt(t, 10).toString().length
    switch (tlen) {
      case 13:
        // 正常时间戳
        res = +t
        break;
      case 10:
        // 秒级时间戳
        res = +t * 1000;
        break;
      default:
        // 不合法时间戳
        throw new Error('timestamp is invalid-->>' + t)
    }
  }
  return res;
}

/**
 * 必传参数校验
 * @param {Array} keys 参数名 
 */
function validRequireParam(keys, target) {
  const targetKeys = Object.keys(target)
  keys.forEach(k => {
    if (!targetKeys.includes(k)) throw new Error(`param "${k}" is required!`)
  })
}

/**
 * 数据种类判断
 */
function getProto(target) {
  return Object.prototype.toString.call(target)
}

/**
 * 不满10补0
 * @param {Number} num 
 */
function lessTen(num) {
  if (!num && num !== 0) return '-'
  return +num < 10 ? `0${num}` : num;
}

export default CountDown